import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/office",
        component: List,
        name: "office-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/office/:id/edit",
        component: Edit,
        name: "office.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/office/create",
        component: Create,
        name: "office.create",
        meta: {
            requiresAuth: true,
        },
    },
];
